import React from 'react';
import { ItemRendererContainer } from '../../styles';
import statusColorMap from 'constants/statusColorMap';
import colors from 'constants/colors';

const ItemRenderer = ({ itemContext, getItemProps }) => {

  const isSelected = itemContext.selected; // Check if item is selected

  const status = itemContext.title?.split('/')[0]
  const name = itemContext.title?.split('/')[1]
  const groupId = itemContext.title?.split('/')[2]

  const color = statusColorMap[status] || statusColorMap['default']; 

  const stringToSeed = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = (hash * 31 + str.charCodeAt(i)) >>> 0; // held as an unsigned 32-bit integer
    }
    return hash;
  }

  const seededRandom = (seed) => {
    // Linear congruential generator
    return function () {
      seed = (seed * 1664525 + 1013904223) >>> 0;
      return seed / 0xFFFFFFFF; // Returns a floating point number between 0 and 1
    };
  }

  const randomHexFromString = (str) => {
    const seed = stringToSeed(str);
    const rng = seededRandom(seed);
    const rangeChoice = rng();
  
    let value1, value2;
    if (rangeChoice < 0.5) {
      // Interval1：0x1F330 - 0x1F37F（816 - 895）
      const index1 = Math.floor(rangeChoice * (0x1F380 - 0x1F330));
      const index2 = Math.floor((rangeChoice * (0x1F380 - 0x1F330) - index1) * 10);
      value1 = 0x1F330 + index1;
      value2 = 0x1F330 + index2;
    } else {
      // Interval2：0x1F400 - 0x1F43F（1024 - 1087）
      const index1 = Math.floor(rangeChoice * (0x1F440 - 0x1F400));
      const index2 = Math.floor((rangeChoice * (0x1F440 - 0x1F400) - index1) * 10);
      value1 = 0x1F400 + index1;
      value2 = 0x1F400 + index2;
    }

    return {value1, value2}; 
  }

  const hexValue = randomHexFromString(groupId);

  return (
    <div
      {...getItemProps({
        style: {
          background: color,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderRadius: '15px',
          border: isSelected ? `2px solid ${colors.white}` : 'none',
        },
      })}
    >
      <ItemRendererContainer>
        {(String.fromCodePoint(hexValue.value1 || "0x1F330") + String.fromCodePoint(hexValue.value2 || "0x1F330") + ' ' + name)}
      </ItemRendererContainer>
    </div>
  );
};

export default ItemRenderer;